import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { api, assetUrl } from "@/lib/api";

interface Props { fileUrl: string; title?: string; className?: string; maxPages?: number; testid?: string }

export function PdfPages({ fileUrl, title, className = "", maxPages = 40, testid = "pdf-pages" }: Props) {
  const fileId = fileUrl.split("/").pop() as string;
  const [count, setCount] = useState<number | null>(null);
  const [err, setErr] = useState(false);
  useEffect(() => { setCount(null); setErr(false); api.get(`/files/${fileId}/pages`).then((r) => setCount(r.data.count)).catch(() => setErr(true)); }, [fileId]);
  if (err) return <div className="p-8 text-center text-sm text-gray-500" data-testid={`${testid}-error`}>Preview unavailable. <a href={assetUrl(fileUrl) || "#"} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-blue-700 underline">Open PDF <ExternalLink size={12} /></a></div>;
  if (count === null) return <div className="p-8 text-center text-sm text-gray-400" data-testid={`${testid}-loading`}>Rendering pages…</div>;
  return (
    <div className={`space-y-3 ${className}`} data-testid={testid}>
      {Array.from({ length: Math.min(count, maxPages) }, (_, i) => (
        <img key={i} src={`${assetUrl(`/api/files/${fileId}/page/${i}`)}`} alt={`${title || "PDF"} page ${i + 1}`} className="w-full rounded border border-black/10 bg-white shadow-sm" loading={i < 2 ? "eager" : "lazy"} data-testid={`${testid}-page-${i}`} />
      ))}
      {count > maxPages && <a href={assetUrl(fileUrl) || "#"} target="_blank" rel="noreferrer" className="block text-center text-xs text-blue-700 underline">Showing first {maxPages} of {count} pages — open the full PDF</a>}
    </div>
  );
}
